var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantBankAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5444_26413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0786 51.6494H107.027V119.264H25.0786V51.6494Z",
    fill: "#475F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94922 48.9902H123.348V54.306H7.94922V48.9902Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1787 114.734H121.117V123.797H10.1787V114.734Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97607 121.984H126.318V131.252H4.97607V121.984Z",
    fill: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6482 0L0.171875 48.9928H131.124L65.6482 0Z",
    fill: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2251 43.5841L65.6474 5.65332L116.068 43.5841H15.2251Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2461 59.958H32.91V109.287H17.2461V59.958Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5137 54.3037H35.6422V58.9712C35.6422 60.0851 34.7393 60.988 33.6254 60.988H16.5305C15.4166 60.988 14.5137 60.0851 14.5137 58.9712V54.3037Z",
    fill: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5309 108.252H33.621C34.7349 108.252 35.6378 109.155 35.6378 110.269V114.736H14.5093V110.27C14.5084 109.157 15.4105 108.253 16.5244 108.252H16.5309Z",
    fill: "#E4E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8179 59.958H73.4818V109.287H57.8179V59.958Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.083 54.3037H76.2116V58.9712C76.2116 60.0851 75.3087 60.988 74.1948 60.988H57.1013C55.9874 60.988 55.0844 60.0851 55.0844 58.9712V54.3037H55.083Z",
    fill: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1015 108.252H74.1934C75.3073 108.252 76.2102 109.155 76.2102 110.269V114.736H55.083V110.27C55.0822 109.157 55.9842 108.253 57.0981 108.252H57.1015Z",
    fill: "#E4E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3853 59.958H114.049V109.287H98.3853V59.958Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6548 54.3037H116.783V58.9712C116.783 60.0851 115.88 60.988 114.767 60.988H97.6716C96.5577 60.988 95.6548 60.0851 95.6548 58.9712V54.3037Z",
    fill: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6718 108.252H114.764C115.877 108.252 116.78 109.155 116.78 110.269V114.736H95.6519V110.27C95.651 109.157 96.5531 108.253 97.667 108.252H97.6718Z",
    fill: "#E4E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2686 21.6332C72.2694 25.2815 69.3125 28.2399 65.6642 28.2407C65.6588 28.2407 65.6534 28.2407 65.648 28.2407C62.004 28.2285 59.0527 25.2773 59.0405 21.6332C59.0428 17.9833 62.0037 15.0261 65.6537 15.0283C69.222 15.0306 72.1443 17.865 72.2555 21.4316C72.2691 21.498 72.2734 21.5657 72.2686 21.6332Z",
    fill: "#475F84"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.906,
    cy: 115.906,
    r: 29.9059,
    fill: "#4B93FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5444_26413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.895 93.0002L134.475 96.2293C135.118 96.4256 135.348 97.218 134.909 97.7278L124.019 110.379C123.58 110.889 123.81 111.681 124.453 111.878L129.178 113.32C129.84 113.522 130.058 114.349 129.582 114.851L118.673 126.362C118.197 126.864 118.416 127.692 119.078 127.894L120.96 128.468C121.777 128.718 121.941 129.802 121.234 130.282L105.854 140.725C104.949 141.339 103.909 140.161 104.631 139.339L111.502 131.517C111.934 131.025 111.736 130.251 111.12 130.027L107.361 128.66C106.724 128.429 106.54 127.617 107.013 127.133L116.371 117.568C116.859 117.068 116.645 116.229 115.977 116.025L109.386 114.014C108.805 113.836 108.546 113.16 108.861 112.641L122.826 93.4092C123.047 93.0442 123.487 92.8758 123.895 93.0002V93.0002Z",
    fill: "#FFEBA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.178 113.32L124.453 111.878C123.81 111.681 123.58 110.889 124.019 110.379L134.909 97.7279C135.348 97.2181 135.118 96.4257 134.475 96.2293L123.895 93.0003C123.487 92.8758 123.047 93.0443 122.826 93.4093L122.236 94.2228L130.267 96.6742C130.911 96.8705 131.14 97.6629 130.701 98.1727L119.811 110.824C119.372 111.334 119.602 112.126 120.245 112.322L124.97 113.765C125.632 113.967 125.85 114.794 125.374 115.296L114.466 126.807C113.99 127.309 114.208 128.137 114.87 128.339L116.752 128.913C117.569 129.162 117.733 130.247 117.027 130.727L105.058 138.853L104.631 139.339C103.909 140.161 104.949 141.339 105.854 140.725L121.234 130.282C121.941 129.802 121.777 128.718 120.96 128.468L119.078 127.894C118.416 127.692 118.198 126.864 118.674 126.362L129.582 114.851C130.058 114.349 129.84 113.522 129.178 113.32Z",
    fill: "#FDDF7C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5444_26413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5444_26413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.2673,
    height: 51.2673,
    fill: "white",
    transform: "translate(100.966 86) rotate(16.9726)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantBankAccount);
export default __webpack_public_path__ + "static/media/instantBankAccount.dead2a027139313892389ef264991379.svg";
export { ForwardRef as ReactComponent };